import React from "react"
import TaskCode from '../../Shared/TaskCode'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'


export default ({ touched, errors, setFieldValue, values, handleBlur, taskType }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>اطلاعات کالا جهت تولید</legend>

        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">کد سفارش</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">میزان سفارش</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                <TaskCode code={values.taskCode} />
              </td>
              <td>
                {values.product && values.product && values.product.category.name}
              </td>

              <td>
                {values.product && values.product && values.product.brand.name}
              </td>
              <td>
                {values.product && values.product && values.product.name}
              </td>
              <td>
                {values.product && values.product && values.product.extraCode}
              </td>
              <td>
                {values.product &&
                  <MeasurementTypeDoubleBox
                    product={values.product}
                    value={values.quantity}
                    onlySub={values.product.subMeasurementType !== undefined ? true : false}
                  />
                }
              </td>
            </tr>
          </tbody>
        </table>





        {/* <div className="row">
          <div className="form-inline">

            <div className="col-md-4 col-sm-12">
              <label>دسته بندی</label>
              <span className="text-label">
                {values.product && values.product.category.name}
              </span>
            </div>

            <div className="col-md-4 col-sm-12">
              <label>برند</label>
              <span className="text-label">
                {values.product && values.product.brand.name}
              </span>
            </div>

            <div className="col-md-4 col-sm-12">
              <label>نام کالا</label>
              <span className="text-label">
                {values.product && values.product.name}
              </span>
            </div>

            <div className="clearfix"></div>

            <div className="col-md-6 col-sm-12">
              <label>میزان سفارش {values && values.product && values.product.measurementType != undefined ? '(' + measurementTypes.filter(el => el.value === values.product.measurementType)[0].label + ')' : ''}</label>
              <span className="text-label">
                {values.quantity}
              </span>
              <ErrorMessage component={ErrorPopUp} name="quantity" />
            </div>

            <div className="col-md-6 col-sm-12">
              <label>میزان سفارش {values && values.product && values.product.subMeasurementType != undefined ? '(' + measurementTypes.filter(el => el.value === values.product.subMeasurementType)[0].label + ')' : ''}</label>
              <span className="text-label">
                {values.product ? ConvertQuantity(values.quantity, values.product.conversionUnit, 3, 2) : ''}
              </span>
              
            </div>
            
            <div className="clearfix"></div>

          </div>
        </div> */}

      </fieldset>

    </div>

  </div>
);